import React from "react";

class Trial extends React.Component{
    render(){
        return(
            <section className="trial" id="trial">
                <div className="container">
                    <div className="trial_txt">
                        <h2>
                            Fresh Life
                        </h2>
                        <p>
                            Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.
                        </p>
                        <a href="#">GET FREE NOW</a>
                    </div>
                </div>
            </section>
        )
    }

}

export default Trial;


// WEBPACK FOOTER //
// ./src/trial.js